import { render } from "./SupplyAndBorrow.vue?vue&type=template&id=2f1c5cfa&scoped=true&ts=true"
import script from "./SupplyAndBorrow.vue?vue&type=script&lang=ts"
export * from "./SupplyAndBorrow.vue?vue&type=script&lang=ts"

import "./SupplyAndBorrow.vue?vue&type=style&index=0&id=2f1c5cfa&scoped=true&lang=scss"
import "./SupplyAndBorrow.vue?vue&type=style&index=1&id=2f1c5cfa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1c5cfa"]])

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress,QTooltip,QLinearProgress});
